import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider, styled } from 'styled-components';
import { AppProvider } from './context/AppContext';

import { theme } from './theme';
import HomePage from './pages/HomePage';
import ConsultaPage from './pages/ConsultaPage';
import PagamentoPage from './pages/PagamentoPage';
import ConsultaCompletaPage from './pages/ConsultaCompletaPage';
import QRCodePage from './pages/QRCodePage';
import NotFoundPage from './pages/NotFoundPage';
import UpsellOnlyPaymentPage from './pages/UpsellOnlyPaymentPage';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ScrollToTop from './components/ScrollToTop'; // <- IMPORTADO AQUI

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <Router>
          <ScrollToTop /> {/* <- INSERIDO AQUI */}
          <AppWrapper>
            <Header />
            <MainContent>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/resultado/:placa" element={<ConsultaPage />} />
                <Route path="/pagamento-itens/:placa/:orderId?" element={<PagamentoPage />} />
                <Route path="/pagamento/upsell/:orderId/:placa?" element={<UpsellOnlyPaymentPage />} />
                <Route path="/pagamento/qrcode/:placa/:orderId?" element={<QRCodePage />} />
                <Route path="/relatorio_completo/:orderId/:placa" element={<ConsultaCompletaPage />} />
                <Route path="/relatorio_upsell/:orderId/:placa" element={<ConsultaCompletaPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </MainContent>
            <Footer />
          </AppWrapper>
        </Router>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
